// @ts-strict-ignore
import { DuplicatedPhonePatientsFailure, HttpError } from 'errors';

import { useStores } from 'mobx/hooks/useStores';

import { TOGGLE_PARAM } from './useToggle';

export function usePostPhoneInUseError(saveAnywayCallback: () => void) {
  const { uiStore } = useStores();

  return (error: HttpError<DuplicatedPhonePatientsFailure>) => {
    const data = error.httpFailure.serverData;
    const saveAnywayAction = {
      actionText: 'Save Shared Number',
      actionCallback: () => {
        saveAnywayCallback();
        uiStore.clearError();
      }
    };
    const cancelAction = {
      actionText: 'Cancel'
    };
    if (data.duplicatedPhonePatients.length === 1) {
      const patientName = data.duplicatedPhonePatients[0].patientName;
      const patientId = data.duplicatedPhonePatients[0].patientId;
      const index = patientName.indexOf(' ');
      const usedFirstName = index === -1 ? patientName : patientName.substring(0, index);

      uiStore.postError(
        error,
        [
          `${patientName} is already using this number.`,
          '⠀',
          `You may save this as a shared number, or edit ${usedFirstName}’s number first.`
        ],
        {
          errorAction: saveAnywayAction,
          additionalAction: {
            actionText: `Edit ${usedFirstName}`,
            actionCallback: () => {
              const win = window.open(`/#/patient/${patientId}?${TOGGLE_PARAM}=true`, '_blank');
              win.focus();
            }
          },
          cancelAction: cancelAction
        }
      );
    }

    if (data.duplicatedPhonePatients.length > 1) {
      const names = data.duplicatedPhonePatients.map((patient) => {
        return `• ${patient.patientName} (MRN: ${patient.mrn})`;
      });
      const errorDescription = [
        'The following patients are already using this number: ',
        ...names,
        '⠀',
        'You may save this as a shared number, or edit their numbers first.'
      ];
      uiStore.postError(error, errorDescription, {
        errorAction: saveAnywayAction,
        cancelAction
      });
    }
  };
}
